"use client"
import type { BLXApplications } from "config/routing"
import type React from "react"
import { capitalizeWord } from "utilities"

import { type BaseThemeTypings, Box, HStack, Heading } from "@chakra-ui/react"

import AppIcon from "./AppIcon"

interface AppNavigationHeaderProps {
    app: BLXApplications
}

const backgroundColors: Record<BLXApplications, BaseThemeTypings["colors"]> = {
    marketMyBrewery: "blue.50",
    performancePlatform: "green.50",
    brewKnowledge: "magenta.50",
    brewMenu: "orange.50"
}

const AppNavigationHeader: React.FC<AppNavigationHeaderProps> = ({ app }) => {
    return (
        <Box
            w='full'
            px={4}
            py={2.5}
            rounded='lg'
            bg={backgroundColors?.[app]}
            _dark={{ bg: "gray.500" }}
            pointerEvents='none'
        >
            <HStack alignItems='center' justifyContent='flex-start' gap={3}>
                <AppIcon app={app} />
                <Heading size='base'>{capitalizeWord(app)}</Heading>
            </HStack>
        </Box>
    )
}

export default AppNavigationHeader
